import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslate } from "../components/TranslationText";
import Loader from "../components/Loader";
import SubmitBtn from "../components/SubmitBtn";
import { useLocation } from "react-router";
import {
  FetchShowEntryClassesthunk,
  FetchShowEntryFilesthunk,
  FetchShowEntrybyIdthunk,
  FetchShowSchedulethunk,
} from "../Redux/ShowEntry/ShowEntryAction";
import { FetchShowbyIdthunk, FetchShowClassRankListthunk, FetchShowGallerythunk, FetchShowJudgesthunk } from "../Redux/Shows/ShowsAction";
import { CompareDate } from "../helper/CompareDate";
import { Link } from "react-router-dom";
import { handelActiveTabOwnerProfile } from "../Redux/ShowEntry/ShowEntrySlice";
import { differenceDaysBetweenTwoDates } from "../helper/differenceDaysBetweenTwoDates";
import { formatDate } from "../helper/formatDate";
import { generateIframeFromUrl } from "../helper/generateIframeFromUrl";
import Popup from "reactjs-popup";
import ActionButton from "../components/ActionButton";
import { StringDateArEn } from "../helper/StringDateArEn";
import CategoryCard from "../components/CategoryCard";
import JudgeList from "../components/JudgeList";
import axiosInstance from "../axios/axios";
import PrizeCard from "../components/PrizeCard";
import { getDayString } from "../helper/getDayString";
import { iconContainer, noDataCard, showIconsContainer, termsTitle, whiteCard } from "../common/cssclasses";
import { formatLongDate } from "../helper/formatLongDate";

const ExeclBaseURL = process.env.REACT_APP_UMBRACO;


export default function ShowEntryDetails() {
  const { currentLanguage } = useSelector((state) => state.studBookSlice);
  const { translate } = useTranslate();
  const [userProfile, setUserProfile] = useState("null");
  const loadDataFromLocal = () => {
    const jsonString = localStorage.getItem("eahsUserProfile");
    if (jsonString) {
      const data = JSON.parse(jsonString);
      setUserProfile(data);
    }
  };
  const {
    showEntryLoading,
    showEntrybyIdData,
    showEntryFilesData,
    showEntryClassesData,
    showScheduleData,
  } = useSelector((state) => state.showEntrySlice);
  // console.log("showEntrybyIdData", showEntrybyIdData);


  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const currentId = searchParams.has("showId")
    ? searchParams.get("showId")
    : null;


  const [showPrizeListForChampions, setShowPrizeListForChampions] = useState([]);
  const [showPrizeListForClasses, setShowPrizeListForClasses] = useState([]);
  async function getShowPrizeList(params) {
    try {
      const response = await axiosInstance.get(`/Shows/GetShowPrizeByShowId?id=${currentId}`);
      if (response.data.responseCode == "200") {
        setShowPrizeListForChampions(response.data.result.showPrizeListForChampions)
        setShowPrizeListForClasses(response.data.result.showPrizeListForClasses)
      } else {
        console.error('error in getting Show Prize List')
      }

    } catch (error) {
      console.error('error in getting Show Prize List API')
    }

  }


  useEffect(() => {
    async function getShowEntrybyId() {
      let paramsShowEntrybyId = {
        id: currentId,
        langauge: currentLanguage,
      };
      dispatch(FetchShowEntrybyIdthunk(paramsShowEntrybyId));
      dispatch(FetchShowGallerythunk(paramsShowEntrybyId));
      dispatch(FetchShowEntryFilesthunk(paramsShowEntrybyId));
      dispatch(FetchShowEntryClassesthunk(paramsShowEntrybyId));
      dispatch(FetchShowSchedulethunk(paramsShowEntrybyId));
      dispatch(handelActiveTabOwnerProfile("showEntry"));
      dispatch(FetchShowJudgesthunk(paramsShowEntrybyId));
      dispatch(FetchShowClassRankListthunk(paramsShowEntrybyId));

    }

    getShowEntrybyId();
    loadDataFromLocal();
    getShowPrizeList();

  }, [dispatch, currentId, currentLanguage]);


  return (
    <>
      {
        // loading div
      }
      <div
        className={`page-overlay text-center ${showEntryLoading ? "classdisplay" : "classnotdisplay"
          }`}
      >
        <div className="loaderDiv">
          <Loader />
        </div>
      </div>

      <div className="row rtl">
        <h2 className={termsTitle + " d-flex align-items-center flex-wrap"}>
          <img src={showEntrybyIdData?.logo} className="me-3 " alt={showEntrybyIdData?.showName} style={{ maxHeight: 60 }} />
          {showEntrybyIdData?.showName}
          <div className={iconContainer + " ms-auto text-end"}>
            {(userProfile.accountType !== 'Organizer' && (showEntrybyIdData?.isLocalRegistrationOpen ||showEntrybyIdData?.isInternationalRegistrationOpen ||showEntrybyIdData?.isFoalRegistrationOpen || showEntrybyIdData?.showParticipantRequestStatus != "New")) && <Link
              className={`btn btn-danger ${CompareDate(
                showEntrybyIdData.registerStartDate,
                showEntrybyIdData.endDate
              )
                ? ""
                : "btn-danger"
                } `}
              disabled={
                CompareDate(
                  showEntrybyIdData.registerStartDate,
                  showEntrybyIdData.endDate
                )
                  ? false
                  : true
              }
              style={CompareDate(
                showEntrybyIdData.registerStartDate,
                showEntrybyIdData.endDate
              )
                ? { opacity: 1, cursor: 'pointer' }
                : { opacity: 0.5, cursor: "not-allowed" }}
              onClick={(event) => {
                if (
                  !CompareDate(
                    showEntrybyIdData.registerStartDate,
                    showEntrybyIdData.endDate
                  )
                ) {
                  event.preventDefault();
                }
              }}
              to={
                showEntrybyIdData.showParticipantRequestStatus === "New" ||
                  showEntrybyIdData.showParticipantRequestStatus ===
                  "Draft" ||
                  showEntrybyIdData.showParticipantRequestStatus ===
                  "Pending" ||
                  showEntrybyIdData.showParticipantRequestStatus ===
                  "Returned"
                  ? `/showParticipate?showId=${currentId}&maxHorses=${parseInt(showEntrybyIdData.maxHorseNumberPerOwner) -
                  parseInt(showEntrybyIdData.completedRequestsCount)
                  }&showNameAr=${showEntrybyIdData.showNameAr
                  }&showNameEn=${showEntrybyIdData.showNameEn
                  }&showId=${currentId}&registerStartDate=${showEntrybyIdData.registerStartDate
                  }&registerEndDate=${showEntrybyIdData.registerEndDate
                  }&registerStartDateInter=${showEntrybyIdData.registerStartDateInter
                  }&registerEndDateInter=${showEntrybyIdData.registerEndDateInter
                  }`
                  : `/showentryconflict?maxHorses=${parseInt(showEntrybyIdData.maxHorseNumberPerOwner)
                  // parseInt(showEntrybyIdData.maxHorseNumberPerOwner) -
                  // parseInt(showEntrybyIdData.completedRequestsCount)
                  }&showNameAr=${showEntrybyIdData.showNameAr
                  }&showNameEn=${showEntrybyIdData.showNameEn
                  }&showId=${currentId}`
              }
            >
              { showEntrybyIdData.showParticipantRequestStatus === "New"
                ? translate("web.participateNow", "Participate Now")
                : showEntrybyIdData.showParticipantRequestStatus ===
                  "Draft" ||
                  showEntrybyIdData.showParticipantRequestStatus ===
                  "Pending" ||
                  showEntrybyIdData.showParticipantRequestStatus ===
                  "Returned"
                  ? translate("web.continue", "Continue")
                  : translate("web.addConflict", "Add Conflict")}
            </Link>}
          </div>
        </h2>

        <div className={showIconsContainer}>
          {!!showEntrybyIdData?.cityName && (
            !!showEntrybyIdData?.mapLocationSharedUrl ?
              <div className={iconContainer}>
                <Link to={showEntrybyIdData?.mapLocationSharedUrl} target="_blank" className="">
                  <i
                    className="fa-solid fa-location-dot red"
                  ></i>
                  <span className="red">
                    {showEntrybyIdData?.cityName}
                  </span>
                </Link>
              </div>
              :
              <div className={iconContainer}>
                <i
                  className="fa-solid fa-location-dot red"
                ></i>
                <span className="">
                  {showEntrybyIdData?.cityName}
                </span>
              </div>
          )}
          {!!showEntrybyIdData?.showRank &&
            <div className={iconContainer}>
              <i
                className="fa fa-trophy fa-location-dot red"
              ></i>
              <span className="">
                {showEntrybyIdData?.showRank}
              </span>
            </div>
          }
          {!!showEntrybyIdData?.startDate &&
            <div className={iconContainer}>
              <i
                className="fa fa-calendar red"
              ></i>
              <span className="">
                {translate(
                  "web.from",
                  "Start Date"
                )}  {formatDate(showEntrybyIdData?.startDate)}
              </span>
            </div>
          }
          {!!showEntrybyIdData?.endDate &&
            <div className={iconContainer}>
              <i
                className="fa fa-calendar red"
              ></i>
              <span className="">
                {translate(
                  "web.to",
                  "end Date"
                )}   {formatDate(showEntrybyIdData?.endDate)}
              </span>
            </div>
          }
          {!!showEntrybyIdData?.registerStartDate &&
            <div className={iconContainer}>
              <i
                className="fa fa-calendar red"
              ></i>
              <span className="">
                {translate(
                  "web.registerFrom",
                  "Reg. From"
                )} {formatDate(showEntrybyIdData?.registerStartDate)}
              </span>
            </div>
          }
          {!!showEntrybyIdData?.registerEndDate &&
            <div className={iconContainer}>
              <i
                className="fa fa-calendar red"
              ></i>
              <span className="">
                {translate(
                  "web.registerTo",
                  "Register End Date"
                )} {formatDate(showEntrybyIdData?.registerEndDate)}
              </span>
            </div>
          }
          {!!showEntrybyIdData?.registerStartDateInter &&
            <div className={iconContainer}>
              <i
                className="fa fa-calendar red"
              ></i>
              <span className="">
                {translate(
                  "web.registerIntFrom",
                  "Register Start Date Inter"
                )} {formatDate(showEntrybyIdData?.registerStartDateInter)}
              </span>
            </div>
          }
          {!!showEntrybyIdData?.registerEndDateInter &&
            <div className={iconContainer}>
              <i
                className="fa fa-calendar red"
              ></i>
              <span className="">
                {translate(
                  "web.registerEndDateInter",
                  "Register End Date Inter"
                )} {formatDate(showEntrybyIdData?.registerEndDateInter)}
              </span>
            </div>
          }

          {showEntrybyIdData.startDate &&
            <>
              <div className={iconContainer}>
                <i
                  className="fa fa-calendar red"
                ></i>
                <span className="">
                  {differenceDaysBetweenTwoDates(
                    new Date(),
                    new Date(showEntrybyIdData.startDate)
                  )}{" "}
                  {translate(
                    "web.daysLeftShow",
                    "days Left for the show"
                  )}
                </span>
              </div>
              <>


                {userProfile.accountType == 'Organizer' &&
                  <Link
                    target="_blank"
                    to={`${ExeclBaseURL}/BackOfficeShow/ExportShowParticipant?id=${currentId}`}
                    className={`btn button-saveasdraft newbtn wd-20`}
                  >
                    {translate('web.getParticipateHorses', 'Get Participate Horses')}
                  </Link>
                }


                
              </>

            </>
          }
        </div>



        <JudgeList showID={currentId} isShowEntryDetailsPage={true} />

        {
          // Categories
        }
        <h3 className="bold my-2">
          {translate("web.categories", "Categories")}
        </h3>
        {!!showEntryClassesData && showEntryClassesData.length > 0 ? (
          showEntryClassesData.map((item, i) => (
            <CategoryCard i={i} item={item} translate={translate} />
          ))
        ) : (
          <div className={noDataCard}>
            {translate("web.nodataFound", "No Data Found !")}
          </div>
        )}


        {/* {Prize List} */}
        {(!!showPrizeListForChampions.length > 0 || !!showPrizeListForClasses.length > 0) && <div className="col-md-12">
          <h3 className="bold my-2">
            {translate("web.prizeMoney", "Prize Money")}
          </h3>
          <div className="row rtl">
            {!!showPrizeListForClasses.length > 0 &&
              <>
                <h5 className="bold my-2">
                  {translate("web.classesPrize", "Classes Prize")}
                </h5>
                {!!showPrizeListForClasses && showPrizeListForClasses.map((prize) => (
                  <div className={"col-lg-4 col-md-6 col-sm-12 mx-md-2 my-2 text-center"}>
                    <PrizeCard data={prize} />
                  </div>
                ))}

              </>
            }
            {!!showPrizeListForChampions.length > 0 &&
              <>
                <h5 className="bold my-2">
                  {translate("web.championsPrize", "Champions Prize")}
                </h5>
                {!!showPrizeListForChampions && showPrizeListForChampions.map((prize) => (
                  <div className={"col-lg-4 col-md-6 col-sm-12 mx-md-2 my-2 text-center"}>
                    <PrizeCard data={prize} specialRanks={true} />
                  </div>))}
              </>}
          </div>
        </div>}

        {
          // location
        }
        {((showEntrybyIdData.address != "" &&
          showEntrybyIdData.address != "undefiend" &&
          showEntrybyIdData.address) ||
          (showEntrybyIdData.mapLocation != "" &&
            showEntrybyIdData.mapLocation != "undefiend" &&
            showEntrybyIdData.mapLocation != null)) && (
            <div className="col-md-12 col-sm-12 mb-main ">
              {showEntrybyIdData.address != "" &&
                showEntrybyIdData.address != "undefiend" &&
                showEntrybyIdData.address && (
                  <div className="col-md-12 col-sm-12 ">
                    <span className="horseMarketCardLabeltitle">
                      {translate("web.address", "Address")}
                    </span>
                    <p>
                      <span className="horseMarketCardLabeltitle ">
                        {showEntrybyIdData.address}
                      </span>
                    </p>
                  </div>
                )}
              {showEntrybyIdData.mapLocation != "" &&
                showEntrybyIdData.mapLocation != "undefiend" &&
                showEntrybyIdData.mapLocation != null && (
                  <div className="col-md-12 col-sm-12">
                    <div className={whiteCard} dangerouslySetInnerHTML={{
                      __html: generateIframeFromUrl(
                        showEntrybyIdData.mapLocation
                      ),
                    }}>
                    </div>
                  </div>
                )}
            </div>
          )}

        {
          // Terms & Conditions
        }
        <div className="col-md-12 col-sm-12 mb-main rtl ">
          <h4 className="bold my-2">
            {translate(
              "web.additionalData",
              "Additional Data"
            )}
          </h4>

          {!!showEntryFilesData &&
            showEntryFilesData.length > 0 &&
            <ul className="list-group">
              {showEntryFilesData.map((fileItem, iFileItem) => (
                <li className="list-group-item" key={iFileItem}>
                  <span className="d-flex align-items-center ">
                    <div className="d-flex align-items-center justify-content-between" >
                      <div className="mx-2" style={{ width: 5, height: 5, background: '#000', border: '1px solid #000', borderRadius: 2.5 }} ></div>
                      {
                        fileItem.fileName
                      }
                    </div>
                    {!!fileItem.url ?
                      <Link to={fileItem.url} target="_blank" key={iFileItem} className="btn btn-danger mx-2" style={{ minWidth: 120 }}>
                        {translate("web.downloadFile", "DownLoad Terms And Conditions File")}
                      </Link>
                      :
                      <Popup
                        overlayStyle={{ zIndex: 5000 }}
                        modal
                        trigger={
                          <div key={iFileItem} className="btn btn-danger mx-2" style={{ minWidth: 120 }}>
                            {translate("web.viewDetails", "View Details")}
                          </div>
                        }
                        closeOnDocumentClick={true}
                        closeOnEscape

                      >
                        {(close) => (
                          <React.Fragment>
                            <div
                              className="text-start"
                              style={{ maxHeight: '60vh', overflowY: 'scroll' }}
                              dangerouslySetInnerHTML={{ __html: fileItem.termsAndConditions }}
                            />
                            <br />
                            <div
                              className="rtl"
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-around',
                              }}
                            >
                              <ActionButton type={'btn'} label={translate("web.close", "close")} onClick={close} text={translate("web.close", "close")} />
                            </div>
                          </React.Fragment>
                        )}
                      </Popup>
                    }
                  </span>
                </li>
              ))}
            </ul>
          }
        </div>

        {
          //Show Schedule
        }
        <div className="col-md-12 rtl">
          <h4 className="bold my-2">
            {translate("web.showSchedule", "Show Schedule")}
          </h4>
          <div className="row">
            {!!showScheduleData && showScheduleData.length > 0 ? (
              showScheduleData.map((item, i) => (
                <div className="col-md-6 mb-main" key={i}>
                  <div className={whiteCard} >
                    <div className="row fw-bold">
                      <p className="col-4">{getDayString(item.dayDisplayName, currentLanguage)}</p>
                      <p className="col-8">{formatLongDate(item?.dayDate)} </p>
                      {/* <p className="col-4">{item?.time}</p> */}
                    </div>
                    {item.showClassesList.map(
                      (showClassesListItem, iShowClassesList) => (
                        <div
                          className="row"
                          key={iShowClassesList}
                        >
                          <div className="col-md-4">
                            <h6>
                              {!!showClassesListItem.classShortName &&
                                showClassesListItem.classShortName}
                            </h6>
                          </div>
                          <div className="col-md-8">
                            <h6>{showClassesListItem.className}</h6>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              ))
            ) : (
              <h2 className="text-danger text-center dblock">
                {translate("web.comingSoon", "Comming Soon...")}
              </h2>
            )}
          </div>
        </div>


      </div>
    </>
  );
}
